/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const DocumentRowHeaderSkeleton = (props) => (
    <ContentLoader
        height={32}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* Name */}
        <rect x="0" y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>

        {/* Type */}
        <rect x={`calc(25% + 10px)`} y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>

        {/* Date */}
        <rect x={`calc(50% + 20px)`} y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>

        {/* Download */}
        <rect x="90%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

    </ContentLoader>
);

